import { defaultDictionaryValueMissing } from '../repository';

export type LabelKey = 'Download' | 'DropdownPlaceholder' | 'PrevSlide' | 'HomePage' | 'NextSlide' | 'Selected' | 'WrittenBy';

export const getDefaultLabelValue = (key: LabelKey): string => {
	switch (key) {
		case 'PrevSlide':
			return 'Forrige slide';
		case 'NextSlide':
			return 'Næste slide';
		case 'WrittenBy':
			return 'Af';
		case 'HomePage':
			return 'Forside';
		default:
			return `${defaultDictionaryValueMissing}:${key}`;
	}
};
